import clsx from 'clsx';
import { forwardRef, memo } from 'react';

import type { TextAreaProps } from './types';

import './TextArea.css';

export const TextArea = memo(
  forwardRef<HTMLTextAreaElement, TextAreaProps>(function TextArea(
    {
      label,
      name,
      value,
      onChange,
      disabled,
      placeholder,
      required,
      status,
      onKeyDown,
      __private,
    },
    ref,
  ) {
    const { ariaDescribedBy, ariaLabelledBy, id } = __private ?? {};
    const ariaLabel = ariaLabelledBy ? undefined : label;

    return (
      <textarea
        aria-describedby={ariaDescribedBy}
        aria-invalid={status === 'critical' || undefined}
        aria-label={ariaLabel}
        aria-labelledby={ariaLabelledBy}
        aria-required={required || undefined}
        className={clsx('eds-text-area', status && `eds-text-area--${status}`)}
        disabled={disabled}
        id={id}
        name={name}
        placeholder={placeholder}
        ref={ref}
        required={required}
        value={value ?? ''}
        onChange={(event) => onChange(event.target.value)}
        onKeyDown={onKeyDown}
      />
    );
  }),
);

TextArea.displayName = 'TextArea';
